import React from 'react'

import photo from '../../images/notFound.avif'

export default function NotFound() {
  return (
    <>

    <div className='d-flex align-items-center justify-content-center mt-5 pt-5'>
     <img src={photo} className='w-25' alt="" />
    </div>

    
    </>
  
  )
}
